import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addAssetAPI, assetDetailAPI, assetListAPI, assignAssetAPI,
    unAssignAssetAPI, updateAssetStatusAPI
} from '../api-requests/assets';
import {
    addAssetRequestError, addAssetRequestSuccess, assetDetailRequestError,
    assetDetailRequestSuccess, assetListRequestError, assetListRequestSuccess,
    assignAssetRequestError, assignAssetRequestSuccess, unAssignAssetRequestError,
    unAssignAssetRequestSuccess, updateAssetStatusRequestError, updateAssetStatusRequestSuccess
} from './asset.action';
import { AssetActionTypes } from './asset.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleUpdateAssetStatusRequest({ payload }) {
    try {
        const response = yield call(updateAssetStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateAssetStatusRequestSuccess(decryptedData))
            } else {
                yield put(updateAssetStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateAssetStatusRequestError(error.response.data))
        }
    }
}

export function* updateAssetStatusReq() {
    yield takeLatest(AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST, handleUpdateAssetStatusRequest)
}

function* handleUnAssignAssetRequest({ payload }) {
    try {
        const response = yield call(unAssignAssetAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(unAssignAssetRequestSuccess(decryptedData))
            } else {
                yield put(unAssignAssetRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(unAssignAssetRequestError(error.response.data))
        }
    }
}

export function* unAssignAssetReq() {
    yield takeLatest(AssetActionTypes.UN_ASSIGN_ASSET_REQUEST, handleUnAssignAssetRequest)
}

function* handleAssignAssetRequest({ payload }) {
    try {
        const response = yield call(assignAssetAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assignAssetRequestSuccess(decryptedData))
            } else {
                yield put(assignAssetRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(assignAssetRequestError(error.response.data))
        }
    }
}

export function* assignAssetReq() {
    yield takeLatest(AssetActionTypes.ASSIGN_ASSET_REQUEST, handleAssignAssetRequest)
}

function* handleAssetListRequest({ payload }) {
    try {
        const response = yield call(assetListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assetListRequestSuccess(decryptedData))
            } else {
                yield put(assetListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(assetListRequestError(error.response.data))
        }
    }
}

export function* assetListReq() {
    yield takeLatest(AssetActionTypes.ASSET_LIST_REQUEST, handleAssetListRequest)
}

function* handleAssetDetailRequest({ payload }) {
    try {
        const response = yield call(assetDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assetDetailRequestSuccess(decryptedData))
            } else {
                yield put(assetDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(assetDetailRequestError(error.response.data))
        }
    }
}

export function* assetDetailReq() {
    yield takeLatest(AssetActionTypes.ASSET_DETAIL_REQUEST, handleAssetDetailRequest)
}

function* handleAddAssetRequest({ payload }) {
    try {
        const response = yield call(addAssetAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addAssetRequestSuccess(decryptedData))
            } else {
                yield put(addAssetRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: AssetActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addAssetRequestError(error.response.data))
        }
    }
}

export function* addAssetReq() {
    yield takeLatest(AssetActionTypes.ADD_ASSET_REQUEST, handleAddAssetRequest)
}